import { defineMessages } from 'react-intl';

export const dateRangeFacetMessages = defineMessages({
  startDate: {
    id: 'daterangeFacetStartDate',
    defaultMessage: 'Start Date',
  },
  endDate: {
    id: 'daterangeFacetEndDate',
    defaultMessage: 'End Date',
  },
});
